import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';

const logos = ['Port Authority NY/NJ', 'NYC SBS', 'NYS MBE', 'OSHA 30'];

const Certifications = () => {
  const downloadPDF = (filename, displayName) => {
    const link = document.createElement('a');
    link.href = `/${filename}`;
    link.download = displayName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
  <Box component="section" id="certifications" sx={{ py: { xs: 8, md: 10 }, backgroundColor: 'background.paper' }}>
    <Container>
      <Grid container spacing={4} alignItems="stretch">
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ height: '100%' }}>
            <Typography variant="overline" color="secondary">
              Certifications & Safety
            </Typography>
            <Typography variant="h2" sx={{ mt: 1, color: 'primary.main' }}>
              We have acquired all the necessary Certifications
            </Typography>
            <Typography variant="body1" sx={{ mt: 2 }}>
              We maintain all licenses, bonding, and safety training required for complex public and private-sector work in the
              Northeast.
            </Typography>
            <Stack spacing={1.5} sx={{ mt: 3 }}>
              <Typography variant="body1">• Bonding capacity: $5M single / $10M aggregate</Typography>
              <Typography variant="body1">• NYS Department of Labor registered contractor</Typography>
              <Typography variant="body1">• OSHA and site-specific safety programs for every crew</Typography>
            </Stack>
            
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4 }}>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() => downloadPDF('ANR Capability Statement.pdf', 'ANR_Capability_Statement.pdf')}
                sx={{ fontWeight: 600 }}
              >
                Download Capability Statement
              </Button>
              <Button
                variant="outlined"
                startIcon={<DownloadIcon />}
                onClick={() => downloadPDF('SKM_C36825110521000.pdf', 'ANR_Professional_Certifications.pdf')}
                sx={{ fontWeight: 600 }}
              >
                Download Certifications
              </Button>
            </Stack>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="subtitle1" sx={{ mb: 3, fontWeight: 600 }}>
                Certifications
              </Typography>
              <Grid container spacing={2}>
                {logos.map((logo) => (
                  <Grid size={{ xs: 6 }} key={logo}>
                    <Box
                      sx={{
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2,
                        p: 2,
                        textAlign: 'center',
                        fontWeight: 600,
                        color: 'text.secondary',
                        minHeight: 100,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {logo}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  </Box>
  );
};

export default Certifications;
